import axios from 'axios';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/autenticacao';

class AutenticacaoService {
    constructor() {
    }

    autenticacao(idCliente, tipo, cpfCnpj, chave, numero) {
        return axios.post(API_URL+'/?idCliente='+idCliente+'&cpfCnpj='+cpfCnpj+'&chave='+chave+"&numero="+numero+"&tipo="+tipo, null,
        { headers: { 'Content-Type': 'application/json; charset=UTF-8' } });
    }

    autenticacaoXml(idCliente, tipo, cpfCnpj, chave, numero) {
      return axios({
        url: API_URL+"/autenticarXml?idCliente="+idCliente+"&cpfCnpj="+cpfCnpj+"&chave="+chave+"&numero="+numero+"&tipo="+tipo,
        method: "POST",
        responseType: "blob",
        data: null,
        headers: {
          'Content-Type':'application/json',
          'authorization':'Bearer ' + (this.token ? this.token.token:'')
      }
      }).then(response => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/xml" })
        );
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        console.log(response);
        fileLink.setAttribute("download", "NotaFiscal.xml");
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    }

    visualisar(idCliente, tipo, cpfCnpj, chave, numero) {
      return axios({
        url: API_URL + "/exportNumero?idCliente="+idCliente+"&cpfCnpj="+cpfCnpj+"&chave="+chave+"&numero="+numero+"&tipo="+tipo,
        method: "POST",
        responseType: "blob",
        data: null,
        headers: {
          'Content-Type':'application/json'
      }
      }).then(response => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        window.open(fileURL);
        console.log(response.data);
      });
    }

    visualisarTermo(id) {
      return axios({
        url: API_URL + "/exportTermo?id="+id,
        method: "POST",
        responseType: "blob",
        data: null,
        headers: {
          'Content-Type':'application/json'
      }
      }).then(response => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        window.open(fileURL);
        console.log(response.data);
      });
    }

    visualisarTermoAutentic(id) {
      return axios({
        url: API_URL + "/exportTermoAutentic?id="+id,
        method: "POST",
        responseType: "blob",
        data: null,
        headers: {
          'Content-Type':'application/json'
      }
      }).then(response => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        window.open(fileURL);
        console.log(response.data);
      });
    }

    validaReciboRetencao(tipo, cpfCnpj, numero, idCliente) {
      return axios.post(API_URL+"/validaReciboRetencao?cpfCnpj="+cpfCnpj+"&numero="+numero+"&tipo="+tipo+"&idCliente="+idCliente,
      { headers: { 'Content-Type': 'application/json; charset=UTF-8' } })
      .then(response => {
        this.visualisarReciboRetencao(tipo, idCliente, response.data);
      });
    }

    consultarRps(tipo, cpfCnpjPrestador, inscricaoPrestador, cpfCnpjTomador, numero, serie, tipoRps, idCliente) {
      return axios.get(API_URL+"/consultarRpsConvertido?cpfCnpjPrestador="+cpfCnpjPrestador+"&inscMunicPrestador="+inscricaoPrestador+"&cpfCnpjTomador="+cpfCnpjTomador+"&numero="+numero+"&tipo="+tipo+"&serie="+serie+"&tipoRps="+tipoRps+"&idCliente="+idCliente,
      { headers: { 'Content-Type': 'application/json; charset=UTF-8' } });
    }

    visualisarNfse(idNfse) {
      return axios({
        url: API_URL + "/exportNfse?idNfse="+idNfse,
        method: "POST",
        responseType: "blob",
        data: null,
        headers: {
          'Content-Type':'application/json'
      }
      }).then(response => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        window.open(fileURL);
        console.log(response.data);
      });
    }

    visualisarReciboRetencao(tipo, idCliente, idNfs) {
        return axios({
          url: API_URL + "/exportRetencao?idCliente="+idCliente+"&idNfs="+idNfs+"&tipo="+tipo,
          method: "POST",
          responseType: "blob",
          data: null,
          headers: {
            'Content-Type':'application/json'
        }
        }).then(response => {
          var fileURL = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          window.open(fileURL);
          console.log(response.data);
        }),
        error => {
          console.log(error);
        };
    }
}

export default new AutenticacaoService();